module.exports = __webpack_public_path__ + "img/mendLesson.eefa23ac.svg";